export const config = {
  title: `Book your ride today`,
  numbers: [`+91 7034 520 002`],
}
